// Form initial values

export const initialValues = {
    cliente: {
        esMenorDeEdad: false,
        actividadEconomica: '',
        caracteristicaCliente:'',
        cargaFamiliar: 0,
        categoriaEspecial: '',
        cedulaRif: "",
        condicionVivienda:'',
        ciudadNacimiento: "",
        nombreCiudadNacimiento: '',
        codigoOtraNacionalidad: "",
        estadoCivil: "",
        estadoNacimiento: "",
        fechaDesde: "",
        fechaNacimiento: "",
        fechaVencimiento: "",
        fechaVenceIdentificacion:'',
        fechaExpedicionIdentificacion:'',
        tipoCliente: '',
        lugarNacimiento: "",
        nacionalidad: "",
        nombreNacionalidad: '',
        nivelAcademico: "",
        nombre: "",
        mail: "",
        nombreCompleto:'',
        nombreOficial: "bc217645",
        actividadEspecifica: "",
        oficinaAsesor: "",
        modo: "I",
        pasaporte: '',
        primerApellido: "",
        profesion: "",
        retiene: "N",
        rif:'',
        tipoRif: '',
        segmento: 0,
        segundoApellido: "",
        sexo: "",
        subSegmento: 0,
        ultActualizaMis: "",
        tipoDocumento: '',
        actividadGeneradoraIngreso: '',
        fechaDesdeCuandoRecibeIngreso: '',
        tipodeMonedaIngreso: '',
        codigoMonedaIngreso: '',
        montoEstimadoDeIngreso: '',
        descripcionDeIngreso: '',
        incomeIsValid: null,
    },
    conyuge: {
        nombre: "",
        primerApellido: "",
        segundoApellido: "",
        tipoDocumento: '',
        cedulaRif: "",
        pasaporte: '',
        fechaVenceIdentificacion: '',
        fuenteOrigen: '',
        codigoRelacion: '',
        nombreRelacion: '',
    },
    dueDiligence: '',
    hasApoderado: '',
    apoderado: {
        nombre: "",
        primerApellido: "",
        segundoApellido: "",
        fechaNacimiento: '',
        tipoDocumento: '',
        cedulaRif: "",
        pasaporte: '',
        fechaVenceIdentificacion: '',
        pais: '',
        nombrePais: '',
        descDireccion: '',
        entidad: '',
        ciudad: '',
        municipio: '',
        parroquia: '',
        urbanizacion: '',
        calle: '',
        identificacionRegistro: '',
        numeroRegistro: '',
        tomoRegistro: '',
        protocolo: '',
        fechaRegistro: ''
    },
    direccion: {
        pais: '',
        nombrePais: '',
        descDireccion: '',
        entidad: '',
        nombreEntidad: '',
        ciudad: '',
        nombreCiudad: '',
        municipio: '',
        nombreMunicipio: '',
        parroquia: '',
        nombreParroquia: '',
        urbanizacion: '',
        nombreUrbanizacion: '',
        callecarretera: '',
        calle: '',
        avenida: '',
        esquina: '',
        observaciones: '',
        tipoInmueble: '',
        nombreInmueble: '',
        nivel: '',
        torre: '',
        piso: '',
        apartamento: '',
        telefono1: {
            codigoArea: "",
            descripcionTipoDireccion: 0,
            identificador: 1,
            numero: "",
            tipo: "C",
            tipoDireccion: "D",
        },
        telefono2: {
            codigoArea: '',
            descripcionTipoDireccion: 0,
            identificador: 2,
            numero: "",
            tipo: '',
            tipoDireccion: "D",
        },
        tipoDireccion: "D",
    },
    socialMediaLinks: [
        {
            tipoDireccion: '',
            descripcionDireccion: '',
        }
    ]
};